// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { EscalatorGroupControl } from './escalator-group-control';


export class EscalatorGroupControlMessage implements flatbuffers.IUnpackableObject<EscalatorGroupControlMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):EscalatorGroupControlMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsEscalatorGroupControlMessage(bb:flatbuffers.ByteBuffer, obj?:EscalatorGroupControlMessage):EscalatorGroupControlMessage {
  return (obj || new EscalatorGroupControlMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsEscalatorGroupControlMessage(bb:flatbuffers.ByteBuffer, obj?:EscalatorGroupControlMessage):EscalatorGroupControlMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new EscalatorGroupControlMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

message():EscalatorGroupControl {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : EscalatorGroupControl.AllRunUp;
}

static startEscalatorGroupControlMessage(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addMessage(builder:flatbuffers.Builder, message:EscalatorGroupControl) {
  builder.addFieldInt16(0, message, EscalatorGroupControl.AllRunUp);
}

static endEscalatorGroupControlMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createEscalatorGroupControlMessage(builder:flatbuffers.Builder, message:EscalatorGroupControl):flatbuffers.Offset {
  EscalatorGroupControlMessage.startEscalatorGroupControlMessage(builder);
  EscalatorGroupControlMessage.addMessage(builder, message);
  return EscalatorGroupControlMessage.endEscalatorGroupControlMessage(builder);
}

unpack(): EscalatorGroupControlMessageT {
  return new EscalatorGroupControlMessageT(
    this.message()
  );
}


unpackTo(_o: EscalatorGroupControlMessageT): void {
  _o.message = this.message();
}
}

export class EscalatorGroupControlMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public message: EscalatorGroupControl = EscalatorGroupControl.AllRunUp
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return EscalatorGroupControlMessage.createEscalatorGroupControlMessage(builder,
    this.message
  );
}
}
